import { start as startStatusWatcher } from "./setup"

export const start = function () {
  startStatusWatcher()
}